(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FormulaDialogController', FormulaDialogController);

    FormulaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FormulaService', 'FormulaCustomService', 'GrowthCustomService', 'ToastrService'];

    function FormulaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FormulaService, FormulaCustomService, GrowthCustomService, ToastrService ) {
        var vm = this;

        vm.formula = entity;
        vm.formulaTypes = ['weight','growth'];
        vm.directions = ['weight -> weight', 'weight -> growth', 'growth -> weight'];
        vm.weightTypes = ['KGS','LBS','MTS'];
        vm.growths = [];
        vm.mode = 0;
        vm.sampleWeight = 1;
        vm.sampleBale = 1;
        vm.resultWeight = 0;
        vm.resultBale = 0;
        vm.clear = clear;
        vm.save = save;
        figureThingsOut();

        vm.activateFormulaType = activateFormulaType;
        vm.activateDirection = activeDirection;
        vm.activateParentString = activateParentString;
        vm.activateResultString = activateResultString;
        vm.checkRate = checkRate;
        vm.checkSampleWeight = checkSampleWeight;
        vm.checkSampleBale = checkSampleBale;
        vm.sampleComputation = sampleComputation;
        vm.onTextClick = onTextClick;

        function fetchKeywords() {
            GrowthCustomService.returnAllGrowths().then( function(data) {
                vm.growths.length = 0;
                vm.growths = data.data;
                if(vm.growths.length > 0) {
                    // ToastrService.success("Successfully fetched Growths","Success!");
                } else {
                    ToastrService.info("Growth list is blank");
                }
            }, function(error) {
                if(error.status !== "404") {
                    ToastrService.error(error.message,"Error!");
                }
                console.log(error.message);
            });
        }

        function activateFormulaType( option ) {
            vm.formula.type = option;
            updateFormulaType();
        }

        function updateFormulaType() {
            if( vm.mode > 0 ) {
                vm.formula.type = vm.formulaTypes[1];
            } else {
                vm.formula.type = vm.formulaTypes[0];
            }
        }

        function activeDirection( option ) {
            vm.direction = option;
            vm.mode = vm.directions.indexOf( option );
            updateFormulaType();
        }

        function activateParentString( option ) {
            vm.formula.parentString = option;
        }

        function activateResultString( option ) {
            vm.formula.resultString = option;
        }

        function checkRate() {
            if( isNaN( vm.formula.rate ) || vm.formula.rate === null ) {
                vm.formula.rate = 0;
            }
        }

        function checkSampleWeight() {
            if( isNaN( vm.sampleWeight ) || vm.sampleWeight === null ) {
                vm.sampleWeight = 0;
            }
        }

        function checkSampleBale() {
            if( isNaN( vm.sampleBale ) || vm.sampleBale === null ) {
                vm.sampleBale = 0;
            }
        }

        function sampleComputation() {
            switch( vm.mode ) {
                case 0:
                    FormulaCustomService.sampleComputationString( vm.formula.rate, vm.sampleWeight, "weight" ).then( function( data ) {
                        vm.resultWeight = data.data;
                    }, function( error ) {
                        if( error.status !== "404" ) {
                            ToastrService.error( "Failed to get computation", "Error");
                        }
                        console.log( error.message );
                    });
                    break;
                case 1:
                    FormulaCustomService.sampleComputationString( vm.formula.rate, vm.sampleWeight, "growth" ).then( function( data ) {
                        vm.resultBale = data.data;
                    }, function( error ) {
                        if( error.status !== "404" ) {
                            ToastrService.error( "Failed to get computation", "Error" );
                        }
                        console.log( error.message );
                    });
                    break;
                case 2:
                    FormulaCustomService.sampleComputationString( vm.formula.rate, vm.sampleBale, "weight" ).then( function( data ) {
                        vm.resultWeight = data.data;
                    }, function( error ) {
                        if( error.status !== "404" ) {
                            ToastrService.error( "Failed to get computation", "Error" );
                        }
                        console.log( error.message );
                    });
                    break;
            }
        }

        function figureThingsOut() {
            fetchKeywords();
            if( vm.formula.id == null ) {

            } else {
                if( vm.formula.type == "weight" ) {
                    vm.mode = 0;
                } else {
                    if( vm.formula.parentString == null ) {
                        vm.mode = 2;
                    } else {
                        vm.mode = 1;
                    }
                }
                vm.direction = vm.directions[vm.mode];
            }
            sampleComputation();
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.formula.id !== null) {
                FormulaService.update(vm.formula, onSaveSuccess, onSaveError);
            } else {
                FormulaService.save(vm.formula, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:formulaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function onTextClick( $event ) {
            $event.target.select();
        }
    }
})();
